export const GET_PIANIFICAZIONE_CALENDARIO_SUCCESS = 'GET_PIANIFICAZIONE_CALENDARIO_SUCCESS';
export const GET_PIANIFICAZIONE_CALENDARIO_FAIL = 'GET_PIANIFICAZIONE_CALENDARIO_FAIL';

export const INIT_PIANIFICAZIONE_CALENDARIO = 'INIT_PIANIFICAZIONE_CALENDARIO';
export const RESET_PIANIFICAZIONI_CALENDARIO_FILTRO = 'RESET_PIANIFICAZIONI_CALENDARIO_FILTRO';
export const INIT_CUSTOM_TOOLBAR = 'INIT_CUSTOM_TOOLBAR';

// utility actions
export const ALL_PLANNING = 'ALL_PLANNING';
export const LABEL_MONTH_AGENDA = 'LABEL_MONTH_AGENDA';
export const SET_MONTH = 'SET_MONTH';

export const GET_PDF_AGENDA_START = 'GET_PDF_AGENDA_START';
export const GET_PDF_AGENDA_SUCCESS = 'GET_PDF_AGENDA_SUCCESS';
export const GET_PDF_AGENDA_ERROR = 'GET_PDF_AGENDA_ERROR';

export const PIANIFICAZIONE_CALENDARIO_CREATE = 'PIANIFICAZIONE_CALENDARIO_CREATE';
export const INITIALIZATION_CALENDARIO = 'INITIALIZATION_CALENDARIO';
export const SAVE_ESTREMI = 'SAVE_ESTREMI';
export const PIANIFICAZIONE_CALENDARIO_RICERCA = 'PIANIFICAZIONE_CALENDARIO_RICERCA';
export const PIANIFICAZIONE_CALENDARIO_RICERCA_SUCCESS = 'PIANIFICAZIONE_CALENDARIO_RICERCA_SUCCESS';
export const PIANIFICAZIONE_CALENDARIO_RICERCA_FAIL = 'PIANIFICAZIONE_CALENDARIO_RICERCA_FAIL';



